import LeaSoriano from "../../../assets/images/directors/lea-soriano.png";
import KathrynSorianoPosadas from "../../../assets/images/directors/kathryn-soriano-posadas.png";
import JosefSoriano from "../../../assets/images/directors/josef-soriano.png";

const Management = () => {
  return (
    <div id='chartListContainer'>
      <ul className='main-list'>
        <li className='list-item main'>
          <div className='image-container'>
            <img src={LeaSoriano} alt='lea-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Lea S. Soriano</div>
            <div className='title'>President</div>
          </div>
        </li>
      </ul>
      <ul className='sub-list'>
        <li className='list-item'>
          <div className='image-container'>
            <img src={KathrynSorianoPosadas} alt='kathryn-soriano-posadas' />
          </div>
          <div className='text-container'>
            <div className='name'>Kathryn Leia S. Soriano-Posadas</div>
            <div className='title'>
              Vice President / Corporate Secretary
            </div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={JosefSoriano} alt='josef-soriano' />
          </div>
          <div className='text-container'>
            <div className='name'>Josef Ryan S. Soriano</div>
            <div className='title'>Director / Treasurer</div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Management;
